import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'charla-ticket-content',
  template: '<div [innerHTML]="sanitizedHtmlInput"></div>',
  encapsulation: ViewEncapsulation.ShadowDom // Or ViewEncapsulation.Emulated
})
export class CharlaTicketContentComponent {
  
    @Input() content: string = ''; // The input from the parent
    sanitizedHtmlInput: SafeHtml = '';

    constructor(private sanitizer: DomSanitizer) {

    }

    ngOnChanges() {

        this.sanitizedHtmlInput = this.sanitizer.bypassSecurityTrustHtml(this.content);

    }

}